import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectParamBookId, selectParamBookLoaded } from './book.selectors';

@Injectable({
  providedIn: 'root',
})
export class BookFacade {
  private readonly store: Store = inject(Store);

  public readonly paramBookId: Signal<string | undefined> =
    this.store.selectSignal(selectParamBookId);
  public readonly paramBookLoaded: Signal<boolean> = this.store.selectSignal(
    selectParamBookLoaded,
  );
}
